// native
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { Subject, BehaviorSubject } from 'rxjs';

// service
import { UtilityService } from './utility.service';

// models
import { IDataItemQueryParams, IDisplayItem, IItem, ISmartciteFetchedItem, ScrollSession } from '../../models';

// constants
import { MAX_AUTHORS_LENGTH, DEFAULT_LIBRARY_SORT_COLUMN, DEFAULT_SORT_ORDER } from '../../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class ItemsDisplayService {

  items: IDisplayItem[];

  panelItem: IDisplayItem;
  panelOptionsItem: IDisplayItem;

  itemParams$: Subject<IDataItemQueryParams> = new Subject<IDataItemQueryParams>();
  itemsVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  itemPanelVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  optionsPanelVisible$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  itemsLoading$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  sort: string = DEFAULT_LIBRARY_SORT_COLUMN;
  order: 'asc' | 'desc' = DEFAULT_SORT_ORDER;

  isNextScrollSearchDisabled: boolean = false;
  scrollSessions = new Map<string, ScrollSession>();

  constructor(
    @Inject(DOCUMENT) private document: HTMLDocument,
    private utilityService: UtilityService
  ) { }

  parseItemsForDisplay(items: (IItem | ISmartciteFetchedItem)[]): IDisplayItem[] {
    return items.map((item: IItem) => {
      // skip case where item is null when deleted after making a citation
      if (!item) {
        return;
      }

      const displayItem: IDisplayItem = Object.assign({}, item);

      displayItem.isChecked = false;

      if (displayItem.article.authors && displayItem.article.authors.length) {
        displayItem.article.displayedAuthors = this.getDisplayedAuthors(<string[]>displayItem.article.authors);
        displayItem.article.nonDisplayedAuthorsCount = displayItem.article.authors.length - displayItem.article.displayedAuthors.length;
      } else {
        displayItem.article.displayedAuthors = [];
        displayItem.article.nonDisplayedAuthorsCount = 0;
      }

      displayItem.article.isFullAuthorsShown = false;

      return displayItem;
    });
  }

  private getDisplayedAuthors(authors: string[]): string[] {
    let totalAuthorChars = 0;

    let displayedAuthorsCount = 0;

    for (const author of authors) {
      totalAuthorChars = totalAuthorChars + author.length;
      if ((totalAuthorChars > MAX_AUTHORS_LENGTH) && (displayedAuthorsCount > 0)) break;
      displayedAuthorsCount++;
    }

    return authors.slice(0, displayedAuthorsCount);
  }

  disableNextScrollSearchIfNeeded(results: IDisplayItem[], isScroll: boolean) {
    this.isNextScrollSearchDisabled = (isScroll && results.length === 0);
  }

  handleScrollingItemPopulation(results: IDisplayItem[], isScroll: boolean, scrollSession: ScrollSession) {
    if (!isScroll || !scrollSession || scrollSession.expired()) {
      this.utilityService.scrollToTop(this.document.querySelector('#scroll-wrapper-items'));

      this.items = results;
      return results;
    }
    this.items = this.items.concat(results);
    return this.items;
  }

  showItemPanel(item: IDisplayItem) {
    this.panelItem = item;
    this.itemPanelVisible$.next(true);
  }

  showItemOptionsPanel(item: IDisplayItem) {
    this.panelOptionsItem = item;
    this.optionsPanelVisible$.next(true);
  }

  getPanelItem(): IDisplayItem {
    return this.panelItem;
  }

  getPanelOptionsItem(): IDisplayItem {
    return this.panelOptionsItem;
  }
}